export const MAX_ATTEMPTS = 5
export const LOCKOUT_MS = 30_000

export type LockoutState = {
  attempts: number
  lockedUntil: number | null
}

export const INITIAL_LOCKOUT: LockoutState = { attempts: 0, lockedUntil: null }

export const nextLockoutState = (state: LockoutState, now: number): LockoutState => {
  const attempts = state.attempts + 1
  return { attempts, lockedUntil: attempts >= MAX_ATTEMPTS ? now + LOCKOUT_MS : null }
}

export const isLockedOut = (state: LockoutState, now: number): boolean =>
  state.lockedUntil !== null && now < state.lockedUntil
